
import React from 'react';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Investment', href: '#investment' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    { name: 'Agricultural Investment', href: '#services' },
    { name: 'Renewable Energy', href: '#services' },
    { name: 'Infrastructure Development', href: '#services' },
    { name: 'Market Analysis', href: '#services' },
    { name: 'Strategic Consulting', href: '#services' }
  ];

  const research = [
    { name: 'Rural Africa Potential', href: '/research/rural-africa-potential' },
    { name: 'Investment Opportunities', href: '/research/why-invest-rural-south-africa' },
    { name: 'Urbanisation Challenges', href: '/research/african-urbanisation-challenges' },
    { name: 'Rural Development', href: '/research/rural-development-land-ownership' },
    { name: 'Market Studies', href: '#research' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/46a311af9e0bece68b4ea3d810aabbdd/eb987e6159ffa742a2f389f2924fddcf.jpeg" 
                alt="TS Dotyeni International Logo" 
                className="h-12 w-auto object-contain"
              />
              <div>
                <h3 className="text-xl font-bold">TS Dotyeni International</h3>
                <p className="text-emerald-400 font-medium">Be Extraordinary</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Unlocking tremendous potential in rural African markets through strategic investments 
              in agriculture, renewable energy, and infrastructure development.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a href={service.href} className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Research */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Research</h4>
            <ul className="space-y-3">
              {research.map((item, index) => (
                <li key={index}>
                  <a href={item.href} className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 TS Dotyeni International. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
